import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';

export const HomlessCondiction = () => {
    const { chartData } = useHomelessChartsDataContext();

    return (
        <SimpleBars
            title={'Pessoa em Situação de Rua - Condição'}
            horizontal={true}
            subtitles={chartData?.homelessCondiction?.map((item) => item.description)}
            values={chartData?.homelessCondiction?.map((item) => item.total  ||  0)}
        />
    );
};
